const state = {
	subMenuColor: 'sub-menu-color-bright',
	menuColor: 'color-style-bright color-style-default',
	menuAnnimation: 'sub-menu-style-over menu-activated-on-hover',
	menuLayout: 'menu-layout-mini',
	menuPosition: 'menu-position-side menu-side-left',
	fullScreen: 'full-screen',
	topBar: 'yes',
	menuImage: 'menu-with-image',
	subTopbarColor: 'color-bright'
}

const mutations = {
	setSubMenuColor: (state, color) => {
		state.subMenuColor = color
	},
	setMenuColor: (state, color) => {
		state.menuColor = color
	},
	setMenuAnimation: (state, annimation) => {
		state.menuAnnimation = annimation
	},
	setMenuLayout: (state, layout) => {
		state.menuLayout = layout
	},
	setMenuPosition: (state, position) => {
		state.menuPosition = position
	},
	setScreen: (state, screen) => {
		state.fullScreen = screen
	},
	setTopbar: (state, barvalue) => {
		state.topBar = barvalue
	},
	setMenuImage: (state, imagemenu) => {
		state.menuImage = imagemenu
	},
	setTopbarColor: (state, topbarcolor) => {
		state.subTopbarColor = topbarcolor
	}
}

const actions = {}

const getters = {}

export default {
	namespaced: true,
	state,
	mutations,
	actions,
	getters
}



// WEBPACK FOOTER //
// ./src/store/modules/ThemePreferences.js